export const DEFAULT_COLUMNS = {
  'column-1': {
    id: 'column-1',
    title: 'planned',
    taskIds: [],
  },
  'column-2': {
    id: 'column-2',
    title: 'in_progress',
    taskIds: [],
  },
  'column-3': {
    id: 'column-3',
    title: 'testing',
    taskIds: [],
  },
  'column-4': {
    id: 'column-4',
    title: 'completed',
    taskIds: [],
  }
};

export const DEFAULT_COLUMN_ORDER = ['column-1', 'column-2', 'column-3', 'column-4'];